import { ReactNode } from 'react';

export function Page({ children }: { children: ReactNode }) {
  return (
    <div className="cm-page">
      <main className="cm-layout">{children}</main>
    </div>
  );
}

export function Field({
  label,
  children,
  htmlFor,
  group = false,
  labelId,
}: {
  label: string;
  children: ReactNode;
  htmlFor?: string;
  group?: boolean;
  labelId?: string;
}) {
  if (group) {
    return (
      <div className="cm-field">
        <span className="cm-field-label" id={labelId}>{label}</span>
        {children}
      </div>
    );
  }
  return (
    <div className="cm-field">
      <label className="cm-field-label" htmlFor={htmlFor}>{label}</label>
      {children}
    </div>
  );
}
